<template>
  <table class="striped equipment-notes">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th class="equipment-note-date">Date</th>
        <th class="equipment-note-author">User</th>
        <th class="equipment-note-message">Notes</th>
        <th class="equipment-note-remove"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(note, index) in paginatedNotes" :key="index">
        <td class="equipment-note-date">
          {{ formatTimestamp(note.createdAt) }}
        </td>
        <td class="equipment-note-author">
          {{ getUserName(note.author) }}
        </td>
        <td
          class="equipment-note-message-text"
          v-html="formatHTML(note.message)"
          v-if="note.id"
        ></td>
        <td class="equipment-note-message-input" v-if="!note.id">
          <textarea
            :id="`equipment-note-${index}-message`"
            placeholder="add note here..."
            required
            v-model.trim="note.message"
          />
        </td>
        <td class="equipment-note-remove">
          <icon-button
            :id="`equipment-note-${index}-remove`"
            name="remove"
            @click="handleRemove(note)"
            v-if="canRemove"
          />
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="page-controls" colspan="4">
          <icon-button
            :disabled="disabled"
            id="equipment-notes-add"
            name="add"
            @click="handleAdd"
            v-if="canAdd"
          />

          <icon-button
            :disabled="!hasPrevPage"
            id="equipment-notes-page-prev"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            id="equipment-notes-page-next"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("notes")],

  props: {
    canAdd: {
      type: Boolean,
      default: true,
    },
    canRemove: {
      type: Boolean,
      default: true,
    },
    caption: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    notes: {
      type: Array,
    },
  },

  methods: {
    handleAdd() {
      this.canAdd &&
        this.$emit("update:notes", [
          {
            author: {
              ...this.$store.getters.user,
              permissions: undefined,
              roles: undefined,
            },
            createdAt: new Date().toJSON(),
          },
          ...this.notes,
        ]);
    },
    handleRemove(note) {
      this.canRemove &&
        this.$emit(
          "update:notes",
          this.notes.filter((n) => n !== note)
        );
    },
  },
};
</script>

<style>
.equipment-notes {
  border-collapse: collapse;
  display: grid;
  grid-template-columns: 6em 12em 1fr 2em;
  margin: 0;
  padding: 0;
  width: 100%;
}

.equipment-notes tbody,
.equipment-notes thead,
.equipment-notes tfoot,
.equipment-notes tr {
  display: contents;
}

.equipment-notes button {
  height: 2em;
  vertical-align: top;
  width: 2em;
}

.equipment-notes thead th {
  background: var(--primary-red);
  color: var(--primary-white);
  text-align: left;
  text-transform: uppercase;
}

.equipment-notes thead th,
.equipment-notes tbody td {
  margin: 0;
  padding: 0.2em 0.2em;
}

.equipment-notes tbody td {
  vertical-align: top;
}

.equipment-notes tbody td.equipment-note-date,
.equipment-notes tbody td.equipment-note-author {
  color: var(--primary-red);
}

.equipment-notes tbody td.equipment-note-message-text {
  max-height: 6em;
  overflow: auto;
}

.equipment-notes tbody td.equipment-note-message-input textarea {
  background: transparent;
  border: none;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  height: 3em;
  resize: vertical;
  width: 100%;
}

.equipment-notes
  tbody
  td.equipment-note-message-input
  textarea::-webkit-input-placeholder {
  color: var(--primary-medium-gray);
  opacity: 1;
}

.equipment-notes tbody td.equipment-note-message-input textarea::placeholder {
  color: var(--primary-medium-gray);
  opacity: 1;
}

.equipment-notes tbody tr:nth-child(2n + 1) td {
  background: var(--primary-light-gray);
}

.equipment-notes tbody td button {
  height: 1.33em;
  width: 1.33em;
}

.equipment-notes tbody td button > i {
  font-size: 0.4em;
}

.equipment-notes tfoot td {
  grid-column: span 4;
  padding-top: 0.4em;
}

.equipment-notes .equipment-note-date {
  width: 6em;
}

.equipment-notes .equipment-note-author {
  width: 12em;
}

.equipment-notes .equipment-note-remove {
  text-align: right;
  width: 2em;
}
</style>